var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaymarket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15243 0.528492C2.46744 0.487593 2.78687 0.557468 3.05603 0.726154L12.2332 5.94304L9.9107 8.29382L2.15243 0.528492ZM1.44649 1.23443C1.40223 1.38812 1.38083 1.54749 1.38296 1.70741V16.2921C1.38083 16.452 1.40223 16.6114 1.44649 16.7651L9.21182 8.99976L1.44649 1.23443ZM9.91776 9.7057L2.15243 17.471C2.46759 17.5156 2.78828 17.4455 3.05603 17.2734L12.2332 12.0565L9.91776 9.7057ZM15.9324 8.0538L13.151 6.4725L10.6096 8.99976L13.1439 11.5341L15.9253 9.95277C16.843 9.43038 16.843 8.56913 15.9253 8.04674L15.9324 8.0538Z",
    fill: "#0082CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaymarket);
export default __webpack_public_path__ + "static/media/playmarket.e4536b1d7507d6ba5c2cb355471fe6e1.svg";
export { ForwardRef as ReactComponent };